import { NgModule } from "@angular/core";
import { PostponedComponent } from "@app/components/postponed/postponed.component";
import { LoaderModule } from "@app/components/loader/loader.module";
import {
  MedCheckboxModule,
  MedDirectiveSharedModule,
  MedPaginationModule, MedRadioGroupModule,
  MedSwitchModule,
  MedTabGroupModule,
} from "@mk/med-ui";
import { PageTitleModule } from "@app/components/page-title/page-title.module";
import { FormsModule } from "@angular/forms";
import { DatePipe, NgClass, NgForOf, NgIf, NgStyle } from "@angular/common";
import { MedIconChevronLeftModule, MedIconChevronRightModule } from "@mk/med-icons";
import { SharedModule } from "primeng/api";
import { TableModule } from "primeng/table";
import { DockModule } from "primeng/dock";

@NgModule({
  declarations: [
    PostponedComponent,
  ],
  imports: [
    LoaderModule,
    MedDirectiveSharedModule,
    MedSwitchModule,
    MedTabGroupModule,
    PageTitleModule,
    FormsModule,
    DatePipe,
    MedCheckboxModule,
    MedIconChevronLeftModule,
    MedIconChevronRightModule,
    MedPaginationModule,
    MedRadioGroupModule,
    NgForOf,
    NgIf,
    SharedModule,
    TableModule,
    NgStyle,
    NgClass,
    DockModule,

  ],
  exports: [],
})
export class PostponedModule {}
